import { render, staticRenderFns } from "./HygieneTable.vue?vue&type=template&id=60801a86&"
import script from "./HygieneTable.ts?vue&type=script&lang=ts&"
export * from "./HygieneTable.ts?vue&type=script&lang=ts&"
import style0 from "./HygieneTable.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports